import { Component, AfterViewInit } from '@angular/core';
import items from '../../../../../assets/json/placement-excellence/client-due-diligence.json';
import { ActivatedRoute } from '@angular/router'; 
import { PlacementExcellenceService } from 'src/app/services/placement-excellence.service';


@Component({
    selector: 'app-client-due-diligence',
    templateUrl: './client-due-diligence.component.html',
    styleUrls: ['./client-due-diligence.component.css'],
    standalone: false
})
export class ClientDueDiligenceComponent implements AfterViewInit {

  tableItems = items;

  constructor (private route: ActivatedRoute, private placementExcellenceService: PlacementExcellenceService) { }

  ngAfterViewInit() {
    this.route.fragment.subscribe(f => this.placementExcellenceService.scroolToElementById(f));
  }
}
